import { formatNumber } from "../../ClientPage/utils";
import { Typo } from "../../Typo";
import {
  changeColors,
  dynamicChange,
  getSign,
} from "../../utils/headlineMetrics";
import { useOverviewAnalytics } from "../OverviewAnalyticsProvider";
import { OverviewError } from "../types";
import { OverviewInfoCardTooltip } from "./OverviewInfoDashboardTooltip";

export type OverviewInfoCardProps = {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  title: string;
  value: number;
  changeInPercent: number;
  period?: string;
  unit?: string;
  tooltipText?: string;
  error?: string;
  isMobile?: boolean;
  isBackoffice?: boolean;
};

export const OverviewInfoCard = ({
  icon: Icon,
  title,
  value,
  changeInPercent,
  period,
  unit,
  tooltipText,
  isMobile = false,
  error,
}: OverviewInfoCardProps) => {
  const { analytics } = useOverviewAnalytics();

  return (
    <div className="flex flex-grow flex-col gap-2 md:p-4">
      <div className="flex flex-col items-start gap-4">
        <div className="flex items-center gap-2">
          <div className="rounded-full bg-surface-foreground-brand p-[6px]">
            <Icon className="h-5 w-5 text-icon-primary" />
          </div>
          <Typo element="h2" type="labelMD" textColor="text-text-secondary">
            {title}
          </Typo>
          {tooltipText && (
            <span className="mt-1 self-start">
              <OverviewInfoCardTooltip
                title={title}
                tooltipText={tooltipText}
                isMobile={isMobile}
                onHover={analytics?.trackOverviewTooltipEvent}
              />
            </span>
          )}
        </div>
        <div className="flex items-baseline gap-1">
          <Typo
            element="h1"
            type={isMobile ? "headingLG" : "heading4XL"}
            textColor="text-text-primary"
          >
            {error == OverviewError.ConvertRateError
              ? "--"
              : formatNumber(value)}
          </Typo>
          <Typo element="p" type="labelSM" textColor="text-text-secondary">
            {unit}
          </Typo>
        </div>
      </div>
      {/* Temporarily disable */}
      {false && (
        <div className="mt-2 flex items-center gap-2">
          <Typo
            element="span"
            type="bodySM"
            textColor={changeColors[dynamicChange(changeInPercent)]}
            classes="rounded-[4px] p-1 text-xs font-normal"
          >
            {error == OverviewError.ConvertRateError
              ? "--%"
              : changePercentFormat(changeInPercent)}
          </Typo>
          <Typo element="p" type="captionXS" textColor="text-text-secondary">
            {period}
          </Typo>
        </div>
      )}
    </div>
  );
};

const changePercentFormat = (changeInPercent: number): string => {
  //should return this for 0: "00.00% but should show 5.00% for 5"
  if (changeInPercent === 0) {
    return "00.00%";
  }
  return `${getSign(changeInPercent)}${changeInPercent.toFixed(2)}%`;
};
